module.exports = require("new-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module3/index.js
 ** module id = 6
 ** module chunks = 0
 **/